// extracted by mini-css-extract-plugin
module.exports = {"Hot":"PoolOverview_Hot__2Uu0K","HotAvault":"PoolOverview_HotAvault__18Gdp"};